export const LOW_CONFIDENCE_BPM_VALUE = 155
